define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/GaFeeSchedule", "lodash.debounce", "moment", "../../utils/TimeUtil", "../domain", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, GaFeeSchedule_1, lodash_debounce_1, moment_1, TimeUtil_1, domain_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GrazingAuthPermit = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    moment_1 = tslib_1.__importDefault(moment_1);
    class GrazingAuthPermit extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "PermitId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TermMonths", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TermMonthsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DeferInitialSchedule", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DeferInitialScheduleError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingArea", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingAreaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingAreaEx", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingAreaExError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingAreaTotal", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingAreaTotalError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsCeaseRenewals", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsCeaseRenewalsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsWithinSrn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsWithinSrnError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Pic", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PicError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GaFeeSchedule", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedGaFeeSchedule", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GaFeeScheduleError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Permit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onChangeBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "originalPermitStartDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, GrazingAuthPermit.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Permit = parent;
            this.PermitId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.GaFeeSchedule = [];
        }
        onRead(entity, parent) {
            this.Permit = parent;
            this.GaFeeSchedule = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.PermitId = (0, EntityUtil_1.toInt)(entity.PermitId);
            a.TermMonths = (0, EntityUtil_1.toInt)(entity.TermMonths);
            a.StartDt = b.StartDt;
            a.DeferInitialSchedule = (0, EntityUtil_1.toInt)(entity.DeferInitialSchedule);
            a.GrazingArea = (0, EntityUtil_1.toFloat)(entity.GrazingArea);
            a.GrazingAreaEx = (0, EntityUtil_1.toFloat)(entity.GrazingAreaEx);
            a.GrazingAreaTotal = (0, EntityUtil_1.toFloat)(entity.GrazingAreaTotal);
            a.IsCeaseRenewals = (0, EntityUtil_1.toInt)(entity.IsCeaseRenewals);
            a.IsWithinSrn = (0, EntityUtil_1.toInt)(entity.IsWithinSrn);
            a.Pic = b.Pic;
            a.GaFeeSchedule = this.mergeArray(a.GaFeeSchedule, b.GaFeeSchedule, GaFeeSchedule_1.GaFeeSchedule);
            a.SelectedGaFeeSchedule = a.SelectedGaFeeSchedule && a.GaFeeSchedule.find(x => x.Id == a.SelectedGaFeeSchedule.Id) ? a.SelectedGaFeeSchedule : null;
            a.Shape = (0, EntityUtil_1.mergePolygon)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.originalPermitStartDate = this.StartDt;
            this.GaFeeSchedule.sort((a, b) => {
                if (a.StartDt < b.StartDt) {
                    return -1;
                }
                else if (a.StartDt > b.StartDt) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
            this.onChangeBatchFn = (0, lodash_debounce_1.default)(this.onChange, 500);
            this.addChangeEventAction("StartDt", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("TermMonths", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("GrazingArea", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("GrazingAreaEx", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("DeferInitialSchedule", this.onChangeBatchFn.bind(this));
            if (this.Permit) {
                this.Permit.addChangeEventAction("FeeApplicationRule", this.onChangeBatchFn.bind(this));
                this.Permit.addChangeEventAction("FeePermitRule", this.onChangeBatchFn.bind(this));
            }
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, GrazingAuthPermit.AliasName);
            this.reset();
            if (!this.IsMarkedForDeletion && this.Permit.IsActive && this.Permit.License.IsPendingApprovalOrApproved) {
                this._validate(validationState, recurseChildren);
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "PermitId", "Permit Id");
                this.validateReqNumber(validationState, "TermMonths", "Term (Months)");
                this.validateReqDate(validationState, "StartDt", "Start Date");
                this.validateReqNumber(validationState, "GrazingArea", "Grazing Area", { precision: 2 });
                this.validateReqNumber(validationState, "GrazingAreaEx", "Grazing Area (Unbenefited)", { precision: 2 });
                this.validateReqNumber(validationState, "GrazingAreaTotal", "GRAZING_AREA_TOTAL", { precision: 2 });
                this.validateReqString(validationState, "Pic", "PIC of Originating Property");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.GaFeeSchedule) {
                for (let x of this.GaFeeSchedule) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                PermitId: this.PermitId,
                TermMonths: this.TermMonths,
                StartDt: this.StartDt,
                DeferInitialSchedule: this.DeferInitialSchedule,
                GrazingArea: this.GrazingArea,
                GrazingAreaEx: this.GrazingAreaEx,
                GrazingAreaTotal: this.GrazingAreaTotal,
                IsCeaseRenewals: this.IsCeaseRenewals,
                IsWithinSrn: this.IsWithinSrn,
                Pic: this.Pic,
                GaFeeSchedule: this.GaFeeSchedule.map(x => x.toJson()),
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        onChange(change) {
            if (this.Permit) {
                this.disableChangeObserver();
                this.calculatePermitMeasurements(change);
                this.calculateDates(change);
                this.calculateFees();
                this.enableChangeObserver();
            }
        }
        calculatePermitMeasurements(change) {
            if (change && change.name == "GrazingArea" || change.name == "GrazingAreaEx") {
                this.GrazingAreaTotal = this.GrazingArea - this.GrazingAreaEx;
            }
        }
        calculateDates(change) {
            if (change) {
                if (this.Permit.License.ActiveLicenseStatus == domain_1.PermitLicenseStatusDomain.Draft) {
                    let feeSchedule = this.GaFeeSchedule && this.GaFeeSchedule.length > 0 ? this.GaFeeSchedule[0] : null;
                    if (change.name == "DeferInitialSchedule") {
                        if (this.DeferInitialSchedule == 1) {
                            this.originalPermitStartDate = this.StartDt;
                            this.StartDt = TimeUtil_1.TimeUtil.getFirstDayOfForthcomingAustralianFiscalYear(new Date(feeSchedule.StartDt)).valueOf();
                        }
                        else {
                            this.StartDt = this.originalPermitStartDate;
                        }
                        feeSchedule.StartDt = this.StartDt;
                        if (this.TermMonths < 12) {
                            feeSchedule.EndDt = (0, moment_1.default)(feeSchedule.StartDt).add(feeSchedule.NoDays, "days").valueOf();
                        }
                        else {
                            feeSchedule.EndDt = TimeUtil_1.TimeUtil.getLastDayOfAustralianFiscalYear(new Date(feeSchedule.StartDt)).valueOf();
                        }
                        feeSchedule.NoDays = (0, moment_1.default)(feeSchedule.EndDt).diff((0, moment_1.default)(feeSchedule.StartDt), "days") + 1;
                    }
                    else if (change.name == "StartDt") {
                        feeSchedule.StartDt = this.StartDt;
                        if (this.TermMonths < 12) {
                            feeSchedule.EndDt = (0, moment_1.default)(feeSchedule.StartDt).add(feeSchedule.NoDays, "days").valueOf();
                        }
                        else {
                            feeSchedule.EndDt = TimeUtil_1.TimeUtil.getLastDayOfAustralianFiscalYear(new Date(feeSchedule.StartDt)).valueOf();
                        }
                        feeSchedule.NoDays = (0, moment_1.default)(feeSchedule.EndDt).diff((0, moment_1.default)(feeSchedule.StartDt), "days") + 1;
                    }
                    else if (change.name == "TermMonths") {
                        if (this.TermMonths < 12) {
                            feeSchedule.EndDt = (0, moment_1.default)(feeSchedule.StartDt).add(this.TermMonths, "months").valueOf();
                        }
                        else {
                            feeSchedule.EndDt = TimeUtil_1.TimeUtil.getLastDayOfAustralianFiscalYear(new Date(feeSchedule.StartDt)).valueOf();
                        }
                        feeSchedule.NoDays = (0, moment_1.default)(feeSchedule.EndDt).diff((0, moment_1.default)(feeSchedule.StartDt), "days") + 1;
                    }
                }
            }
        }
        calculateFees(change) {
            (0, EventManager_1.notify)("Calculating Fees");
            services_1.SrmsServiceManager.Instance.PermitApplication.calculateGrazingAuthorityPermitFees(this.Permit.toJson()).then(res => {
                if (res) {
                    this.Permit.FeeApplication = res.FeeApplication;
                    this.Permit.FeePermit = res.FeePermit;
                    this.Permit.FeeTotal = res.FeeTotal;
                    this.Permit.FeeStateGov = res.FeeStateGov;
                    this.Permit.FinalFeeTotal = res.FinalFeeTotal;
                    this.Permit.FinalFeeStateGov = res.FinalFeeStateGov;
                }
            });
            if (this.SelectedGaFeeSchedule && this.SelectedGaFeeSchedule.Lotplan && this.SelectedGaFeeSchedule.LotplanArea != 0 && this.SelectedGaFeeSchedule.LotplanValuation != 0) {
                services_1.SrmsServiceManager.Instance.PermitApplication.calculateGrazingAuthorityScheduleFees(this.SelectedGaFeeSchedule.toJson(), this.GrazingAreaTotal, this.IsWithinSrn == 1).then(res => {
                    if (res) {
                        this.SelectedGaFeeSchedule.merge(res);
                    }
                });
            }
        }
    }
    exports.GrazingAuthPermit = GrazingAuthPermit;
    Object.defineProperty(GrazingAuthPermit, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "GrazingAuthPermit"
    });
    Object.defineProperty(GrazingAuthPermit, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Grazing Authority"
    });
    Object.defineProperty(GrazingAuthPermit, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "PermitId", "TermMonths", "StartDt", "DeferInitialSchedule", "GrazingArea", "GrazingAreaEx", "GrazingAreaTotal", "IsCeaseRenewals", "IsWithinSrn", "Pic", "Shape"]
    });
    Object.defineProperty(GrazingAuthPermit, "PermitIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingAuthPermit, "TermMonthsDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingAuthPermit, "TermMonthsReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingAuthPermit, "StartDtTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the expected start date of the Grazing Authority"
    });
    Object.defineProperty(GrazingAuthPermit, "StartDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingAuthPermit, "DeferInitialScheduleReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GrazingAuthPermit, "GrazingAreaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingAuthPermit, "GrazingAreaExReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingAuthPermit, "GrazingAreaTotalReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GrazingAuthPermit, "IsCeaseRenewalsReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GrazingAuthPermit, "IsWithinSrnReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GrazingAuthPermit, "PicLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 200
    });
    Object.defineProperty(GrazingAuthPermit, "PicTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Property Identification Code of originating property"
    });
    Object.defineProperty(GrazingAuthPermit, "PicReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "PermitId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "PermitIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "TermMonths", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "TermMonthsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "StartDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "StartDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "DeferInitialSchedule", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "DeferInitialScheduleError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "GrazingArea", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "GrazingAreaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "GrazingAreaEx", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "GrazingAreaExError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "GrazingAreaTotal", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "GrazingAreaTotalError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "IsCeaseRenewals", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "IsCeaseRenewalsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "IsWithinSrn", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "IsWithinSrnError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "Pic", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "PicError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "GaFeeSchedule", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "SelectedGaFeeSchedule", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "GaFeeScheduleError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GrazingAuthPermit.prototype, "Permit", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingAuthPermit.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingAuthPermit.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingAuthPermit.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingAuthPermit.prototype, "onChange", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingAuthPermit.prototype, "calculatePermitMeasurements", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingAuthPermit.prototype, "calculateDates", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GrazingAuthPermit.prototype, "calculateFees", null);
});
